module.exports = __webpack_public_path__ + "static/img/55.fd62893.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/55.png
// module id = ojfA
// module chunks = 1